import React from 'react';
import { motion } from 'framer-motion';

export default function Card({ children, className = '', style = {}, noHover = false, delay = 0, ...props }) {
  return (
    <motion.div
      className={`card ${className}`.trim()}
      style={style}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: 'easeOut', delay }}
      whileHover={!noHover ? { y: -4, boxShadow: '0 20px 40px -5px rgba(0, 0, 0, 0.12), inset 0 0 0 1px rgba(255, 255, 255, 0.5)' } : undefined}
      {...props}
    >
      {children}
    </motion.div>
  );
}
